/**
 * The Favorites API path.
 */
export const favoritesAPIPath = "/favorites";
